import type { ApiError } from '../api/client';
import { isTranslationKey, useI18n } from '../i18n';

/**
 * Affiche une erreur d'API en langage courant.
 *
 * `private_network` reçoit un traitement à part : c'est le seul cas où un message
 * détaillé coûte moins cher qu'un ticket de support. Un client dont le serveur est rejeté
 * parce que nginx ne transmet pas l'adresse réelle n'a aucun moyen de le deviner seul.
 */
export function ErrorBanner({ error }: { error: ApiError | null }) {
  const { t } = useI18n();
  if (!error) return null;

  if (error.code === 'private_network') {
    return (
      <div className="banner banner-error" role="alert">
        <strong>{t('error.private_network.title')}</strong>
        <p>{t('error.private_network.body')}</p>
      </div>
    );
  }

  const key = `error.${error.code}`;
  const message = isTranslationKey(key) ? t(key) : t('error.internal_error');

  // Le serveur renvoie parfois une précision exploitable — jusqu'à quand court un délai,
  // sur quel serveur une licence est déjà posée.
  const until = typeof error.payload.until === 'string' ? error.payload.until : null;
  const serverName = typeof error.payload.serverName === 'string' ? error.payload.serverName : null;

  return (
    <div className="banner banner-error" role="alert">
      <p>{message}</p>
      {serverName ? <p className="hint">{t('licenses.activeOn', { server: serverName })}</p> : null}
      {until ? <p className="hint">{t('licenses.cooldown', { duration: until })}</p> : null}
    </div>
  );
}
